import MainAdminProjects from './MainAdminProjects';

export default MainAdminProjects;
